export default {
  allCustomers: [],
}
